@let details = dataEntryDetails();

<div class="data-entry-details bg-card border rounded shadow-sm mb-3">
    <div class="data-entry-details__header d-flex align-items-start justify-content-between gap-3 p-2">
        <div class="d-flex flex-column gap-2">
            <span class="data-entry-details__title fw-semibold">{{ details | translateToken: "name" }}</span>

            @if (badges().length) {
                <div class="d-flex flex-wrap gap-2">
                    @for (badge of badges(); track $index) {
                        <span class="data-entry-details__badge border">
                            @if (badge.token) {
                                {{ details | translateToken: badge.token }}
                            } @else {
                                {{ badge.key! | translate }}
                            }
                        </span>
                    }
                </div>
            }
        </div>

        <button
            type="button"
            class="data-entry-details__toggle d-flex align-items-center gap-2"
            [attr.aria-expanded]="isExpanded()"
            (click)="toggleDetails()"
        >
            <fa-icon [icon]="toggleIcon()" size="xs"></fa-icon>
        </button>
    </div>

    @if (isExpanded()) {
        <div class="data-entry-details__body border-top p-2">
            <div class="row g-3">
                @for (field of fields(); track field.token) {
                    <div class="col-12" [class.col-md-6]="!field.fullWidth" [class.col-xl-4]="!field.fullWidth">
                        <div class="data-entry-details__label">{{ field.label | translate }}</div>
                        <div class="data-entry-details__value">{{ details | translateToken: field.token }}</div>
                    </div>
                }

                @if (details.formula && !hasNoFormula()) {
                    <div class="col-12">
                        <div class="data-entry-details__label">{{ "data_entry.formula" | translate }}</div>
                        <div class="data-entry-details__value" [innerHTML]="formula()"></div>
                    </div>
                }
            </div>
        </div>
    }
</div>
